/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRewindBackward40 = createReactComponent("outline", "rewind-backward-40", "IconRewindBackward40", [["path", { "d": "M19.007 16.466a6 6 0 0 0 -4.007 -10.466h-11", "key": "svg-0" }], ["path", { "d": "M12 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M6 14v2a1 1 0 0 0 1 1h1", "key": "svg-2" }], ["path", { "d": "M9 14v6", "key": "svg-3" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-4" }]]);

export { IconRewindBackward40 as default };
//# sourceMappingURL=IconRewindBackward40.mjs.map
